<div class="card" [ngClass]="order?.isB2b ? 'b2b-card' : ''">
  <div class="orderDetails">
    <ion-grid>
      <div class="order-container">
        <ion-chip class="tokenb2b" *ngIf="order.isB2b">
          {{'B2B' | language : 'B2B'}}
        </ion-chip>
        <ion-chip class="tokenb2c" *ngIf="!order.isB2b">
          {{'B2C' | language : 'B2C'}}
        </ion-chip>
        <p class="orderId" (click)="gotoOrderDetails(order)">{{'order' | language : 'Order #'}}: {{order.orderID |
          textTruncate : 11}} </p>
      </div>
      <ion-row>
        <ion-col size="auto">
          <img *ngIf="order.userDetails.image != ''" src="{{order.userDetails.image}}" alt="profilePic"
            class="profilePic" />
          <div *ngIf="order.userDetails.image == ''" class="profileTxt">
            {{getCharector(order?.userDetails?.name)}}
          </div>
          <a href="tel:{{order?.userDetails?.phone}}" class="callIcon"><img src="/assets/images/Group 7995.svg"
              alt="call-icon" /></a>
        </ion-col>
        <ion-col class="info" (click)="gotoOrderDetails(order)" size="auto">
          <ion-row class="stock">
            +91 {{order.userDetails.phone}}
          </ion-row>
          <ion-row class="name">
            {{order?.userDetails?.name}}
          </ion-row>
          <ion-row class="ion-align-items-center">
            <ion-col size="auto">
              <ion-icon name="location-outline"></ion-icon>
            </ion-col>
            <ion-col>
              <p class="address">{{order?.delivery?.location?.address}}</p>
            </ion-col>
          </ion-row>
          <ion-row class="pickup">
            <img *ngIf="order?.delivery?.mode != 'PICKUP'" src="assets/images/truck.svg" alt="" srcset="" />
            <img *ngIf="order?.delivery?.mode == 'PICKUP'" src="assets/images/hand.svg" alt="" srcset="" />
            <p class="status">{{order?.delivery?.mode |language: order?.delivery?.mode}}</p>
          </ion-row>
        </ion-col>
        <ion-col class="price">
          <ion-row class="row">
            <span *ngIf="order.delivery.mode == 'PICKUP' && order.status == 'COMPLETED'">
              <img src="\assets\images\order_status\pickup completed.svg" alt="profilePic" class="" />
            </span>
            <span *ngIf="order.delivery.mode == 'PICKUP' && order.status == 'CANCELLED'">
              <img src="\assets\images\order_status\pickup cancelled.svg" alt="profilePic" class="" />
            </span>
            <span *ngIf="order.delivery.mode == 'PICKUP' && order.status == 'REJECTED'">
              <img src="\assets\images\order_status\pickup rejected.svg" alt="profilePic" class="" />
            </span>
            <span *ngIf="order.delivery.mode == 'DELIVERY' && order.status == 'COMPLETED'">
              <img src="\assets\images\order_status\delivery completed.svg" alt="profilePic" class="" />
            </span>
            <span *ngIf="order.delivery.mode == 'PICKUP' && order.status == 'NO_SHOW'">
              <img src="\assets\images\order_status\pickup no show.svg" alt="profilePic" class="" />
            </span>
            <span *ngIf="order.delivery.mode == 'PICKUP' && order.status == 'DELIVERED'">
              <img src="\assets\images\order_status\pickup payment pending.svg" alt="profilePic" class="" />
            </span>
            <span *ngIf="order.delivery.mode == 'DELIVERY' && order.status == 'CANCELLED'">
              <img src="\assets\images\order_status\delivery cancelled.svg" alt="profilePic" class="" />
            </span>
            <span *ngIf="order.delivery.mode == 'DELIVERY' && order.status == 'REJECTED'">
              <img src="\assets\images\order_status\delivery rejected.svg" alt="profilePic" class="" />
            </span>
            <span *ngIf="order.delivery.mode == 'DELIVERY' && order.status == 'NO_SHOW'">
              <img src="\assets\images\order_status\delivery no show.svg" alt="profilePic" class="" />
            </span>
            <span *ngIf="order.delivery.mode == 'DELIVERY' && order.status == 'DELIVERED'">
              <img src="\assets\images\order_status\delivery payment pending.svg" alt="profilePic" class="" />
            </span>
          </ion-row>
          <ion-row class="total" *ngIf="order.status != orderStatus.DELIVERY">
            <div class="dispatch-user calander-view" (click)="commonService.featureNotAvailable()"
              *ngIf="order.status != orderStatus.NEW && showButton">
              <img src="assets/images/ic_yellow_calender.svg" alt="pickup" />
            </div>
            {{order.amount - (order.discount?order.discount:0) | currency:'INR':true :'0.0-2'}}
          </ion-row>
          <ion-row class="total" *ngIf="order.status == orderStatus.DELIVERY">
            <div class="profileTxt">
              <ion-icon name="person-circle-sharp" size="large"></ion-icon>
            </div>
            <p class="orderof">{{order?.deliveryBoy?.name}}</p>
          </ion-row>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>

  <div *ngIf="showButton">
    <div class="btns" *ngIf="order.status == orderStatus.NEW">
      <ion-button shape="round" fill="clear" class="reject" (click)="openCancelModal(order, 'REJECTED')">
        {{'Reject' | language : 'Reject'}}</ion-button>
      <ion-button shape="round" class="accept" (click)="orderStatusChangeView(order, 'ACCEPTED')">
        {{'Accept ' | language : 'Accept'}}</ion-button>
    </div>

    <div class="btns" *ngIf="order.status == orderStatus.ACCEPTED">
      <ion-button shape="round" fill="clear" class="reject" (click)="openCancelModal(order, 'CANCELLED')">{{'cancel' |
        language : 'Cancel'}}</ion-button>
      <ion-button shape="round" class="accept" (click)="orderStatusChangeView(order, 'PROCESSING')">
        {{'Process' | language : 'Process'}}</ion-button>
    </div>

    <div class="btns" *ngIf="order.status == orderStatus.PROCESSING">
      <ion-button shape="round" fill="clear" class="reject" (click)="openCancelModal(order, 'CANCELLED')">
        {{'cancel' | language : 'Cancel'}}</ion-button>
      <ion-button shape="round" class="accept"
        (click)="orderStatusChangeView(order, 'READY')">{{'ready'|language:'Ready'}}</ion-button>
    </div>

    <div class="btns" *ngIf="order.status == orderStatus.READY">
      <ion-button shape="round" fill="clear" class="reject" *ngIf="order.delivery.mode == 'PICKUP'"
        (click)="openCancelModal(order, 'NO_SHOW')">
        {{'noshow' | language : 'No show'}}
        <ion-icon class="end-icon" slot="end" src="assets/icon/ic_cross.svg"></ion-icon>
      </ion-button>
      <ion-button shape="round" class="accept" *ngIf="order.delivery.mode == 'PICKUP'"
        (click)="orderStatusChangeView(order, 'DELIVERY')">
        {{'pickUp' | language : 'Pickup'}}
        <ion-icon class="end-icon" slot="end" src="assets/icon/ic_right.svg"></ion-icon>
      </ion-button>

      <ion-button shape="round" fill="clear" class="reject" *ngIf="order.delivery.mode != 'PICKUP'"
        (click)="openCancelModal(order, 'CANCELLED')">{{'cancel' | language : 'Cancel'}}</ion-button>
      <ion-button shape="round" class="accept" *ngIf="order.delivery.mode != 'PICKUP'"
        (click)="orderStatusChangeView(order, 'DELIVERY')">{{'pickUp' | language : 'Pickup'}}</ion-button>
    </div>

    <div class="btns" *ngIf="order.status == orderStatus.DELIVERY">
      <ion-button shape="round" class="accept-full" (click)="orderStatusChangeView(order, 'DELIVERED')">{{'Pickup' |
        language : 'Pickup '}}</ion-button>
    </div>

    <div class="btns" *ngIf="order.status == 'DELIVERED'">
      <ion-button *ngIf="order.payment.paid == false" shape="round" class="accept-full"
        (click)="checkPaymentAcknowledgement(order)">
        {{'PaymentReceived'|language:'Payment Received'}}
      </ion-button>
      <ion-button *ngIf="order.payment.paid == true" shape="round" class="accept-full"
        (click)="checkPaymentAcknowledgement(order)">
        <ion-icon class="end-icon" slot="start" src="assets/icon/ic_doneall.svg"></ion-icon>
        {{'ConfirmPayment'|language:'Confirm Payment'}}
      </ion-button>
    </div>
  </div>
</div>